import { ADMIN_GET_USERS } from "../../types";

const initialState = {
    users : []
}

export default function(state = initialState, action){
    switch (action.type) {
        case ADMIN_GET_USERS:   
            return {
                ...state,
                users : action.payload
            } 
        default :
            return state;   
    }
}